
/*
 * Date: 2025
 * Description: Component that renders prices lowest prices cost by items
 * Author: Philippe Leroux @ skitsc
 */

//Modules
import { ReactElement , useState } from "react";
import { Box , Typography } from "@mui/material";

//Interfaces
import { i_complete_list } from "../../interfaces/items.interface";

const CountBaseCost = ( userList : i_complete_list ): ReactElement => {
    const [ hover , setHover ] = useState<boolean>(false)
    const [anchorPos, setAnchorPos] = useState<{ top: number; left: number } | null>(null);

    const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
        //Here we set the pause relative to the price title..
        const rect = event.currentTarget.getBoundingClientRect();
        setAnchorPos({
            top: rect.top,
            left: rect.right, 
        });
        setHover(true);
    };

    const handleMouseLeave = () => {
        setHover(false);
        setAnchorPos(null);
    };
    const Items = userList.items
    var grandTotal = 0;

    const parsePrice = (value: string | null | undefined): number | null => {
        if (!value) return null;
        const cleaned = value.replace(/[^0-9.-]+/g, '');
        const parsed = parseFloat(cleaned);
        return isNaN(parsed) ? null : parsed;
    };
    const resumeItems : { vendor: string, price: number }[] = []
    for (let i = 0; i < Items.length; i++) {
        const vendors = Items[i].vendors;
        const vendorPrices: { vendor: string, price: number }[] = [];


        const extractPrices = (arr: any[], vendorName: string) => {
            arr.forEach(v => {
                const price = parsePrice(v.price);
                if (price !== null) {
                    vendorPrices.push({ vendor: vendorName, price });
                }
            });
        };

        extractPrices(vendors.tiger , 'tiger');
        extractPrices(vendors.rockauto , 'rockauto');
        extractPrices(vendors.moneydex , 'moneydex');
        extractPrices(vendors.atpac , 'atpac');
        extractPrices(vendors.avatar , 'avatar');
        extractPrices(vendors.lkq , 'lkq');
        if (vendorPrices.length > 0) {
            const lowest = vendorPrices.reduce((min, current) =>
                current.price < min.price ? current : min
            );
            grandTotal += lowest.price;
            const cleanItem = lowest
            resumeItems.push(cleanItem)
        }
    }
    return (
        <Box sx={{ position: "relative", display: "inline-block", mt: "8px", ml: "4px" }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} >
            <Typography>{grandTotal.toFixed(2)}$</Typography>
            {hover && anchorPos && (
                <Box sx={{ position: "fixed", top: anchorPos.top, left: anchorPos.left + 8, backgroundColor: "white", border: "1px solid #ccc", boxShadow: 3, padding: 1, zIndex: 1300, borderRadius: 1, minWidth: "150px", }} >
                    {resumeItems.map((item, index) => (
                        <Box key={index}>
                            <Typography variant="body2">
                                {item.vendor}: ${item.price.toFixed(2)}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    )
}

export default CountBaseCost;